import React from 'react';
import { Stack } from '@mui/material';
import { useFormDefinitionQuery } from '@uplift/queries';
import { Chip } from '@uplift/ui-v2';
import { useAssessmentKeysList } from './hooks';


const FormChip: React.VFC<{
  selected: boolean;
  formId: string;
  onSelect: () => void;
}> = (props) => {
  const { data } = useFormDefinitionQuery(props.formId);

  return (
    <Chip
      clickable
      onClick={props.onSelect}
      label={data.name}
      size="small"
      variant={props.selected ? 'filled' : 'outlined'}
      color="primary"
      sx={{ minWidth: 64 }}
    />
  );
};


export type SourceChipFilterValue = undefined | 'patient' | 'administer';
export const SourceChipFilter: React.VFC<{
  value?: SourceChipFilterValue;
  setValue: (v?: SourceChipFilterValue) => void;
}> = (props) => {
  return (
    <Stack direction="row" gap={1}>
      <Chip clickable onClick={() => props.setValue(undefined)} label="All sources" size="small" variant={!props.value ? 'filled' : 'outlined'} color="primary" />
      <Chip clickable onClick={() => props.setValue('patient')} label="Patient-completed" size="small" variant={props.value === 'patient' ? 'filled' : 'outlined'} color="primary" />
      <Chip clickable onClick={() => props.setValue('administer')} label="Clinician-administered" size="small" variant={props.value === 'administer' ? 'filled' : 'outlined'} color="primary" />
    </Stack>
  );
};


export const FormsChipFilter: React.VFC<{ value: string; setValue: (v?: string) => void }> = (props) => {
  const items = useAssessmentKeysList();

  return (
    <Stack direction="row" gap={1} flexWrap="wrap">
      {items.map(e => (
        <FormChip
          key={e.key}
          formId={e.formId}
          onSelect={() => props.setValue(e.key)}
          selected={props.value === e.key}
        />
      ))}
    </Stack>
  );
};
